import { Currency } from '@/core/currency/interfaces';

const CHF: Currency = {
    name: 'Swiss Franc',
    demonym: 'Swiss',
    majorSingle: 'Franc',
    majorPlural: 'Francs',
    codeNumeric: '756',
    symbol: 'Fr.',
    symbolNative: '₣',
    minorSingle: 'Centime',
    minorPlural: 'Centimes',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'CHF',
    delimiters: {
        thousands: ',',
        decimal: '.'
    }
};

export default CHF;
